export const USER_ROLES = {
	RETAILER: 'retailerUser',
	STANDARD: 'user',
	MARKETPLACES: 'marketplacesUser'
}